<!--  -->
<template>
  <div class='EchartPractice'>
    <div :class="className"
         :id="id"
         :style="{width: '100%', height: '250px'}"></div>
  </div>
</template>

<script>
import * as echarts from 'echarts'

export default {
  name: 'echart-pie',
  props: {
    className: {
      type: String,
      default: 'chartPiesolid',
    },
    id: {
      type: String,
      default: 'chartPiesolid',
    },
    titletop: {
      type: String,
    },
    itemsData: {
      type: Array,
    },
  },
  data() {
    return {
      chart: null,
    }
  },
  mounted() {
    this.DrawBarChart()
  },
  watch: {
    itemsData: {
      handler(newName, oldName) {
        if (oldName) {
          this.DrawBarChart()
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    DrawBarChart() {
      this.chart = echarts.init(document.getElementById(this.id))
      this.chart.showLoading({
        text: 'loading',
        color: '#0084cd',
        textColor: '#0084cd',
        maskColor: 'rgba(255, 255, 255, 0.2)',
        zlevel: 0,
      })
      let colors = ['#179F5D', '#4A8AF3', '#DA4C3F']
      var app = {}

      let option

      option = {
        title: {
          text: this.titletop,
          left: 'left',
          textStyle: {
            color: '#666',
            fontWeight: '100', //粗细
            fontSize: 13,
          },
        },
        icon: 'circle',
        tooltip: {
          trigger: 'item',
        },
        legend: {
          bottom: '10%',
          left: 'center',
        },
        series: [
          {
            type: 'pie',
            radius: '50%',
            height: '80%',
            minAngle: 15,
            data: this.itemsData,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)',
              },
            },
            label: {
              alignTo: 'edge',
              formatter: '{name|{b}}\n{time|{c} }',
              // minMargin: 50,
              edgeDistance: 10,
              lineHeight: 15,
              rich: {
                time: {
                  fontSize: 10,
                  color: '#999',
                },
              },
            },
          },
        ],
      }
      setTimeout(() => {
        // setOption前隐藏loading事件
        this.chart.hideLoading()
        this.chart.setOption(option, true)
      }, 1000)
    },
  },
}
</script>
<style lang="less" scoped>
.EchartPractice {
  padding-top: 10px;
}
// .chartPiesolid {
//   margin-left: 5%;
// }
</style>